import {
  Box,
  Popover,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Skeleton,
  useTheme,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { setselectedTime } from "../../store/slice/Salon.slice";

const TimeComponent = ({ isOpen, handleClose, Ref, loader }) => {
  const theme=useTheme()
  const [anchorOriginVert, setAnchorOriginVert] = useState("bottom"); // default
  const [transformOriginVert, setTransformOriginVert] = useState("top"); // default
  const dispatch = useDispatch();
  const { avilabilityTime, selectedTime, languageWords } = useSelector(
    (store) => store?.salon
  );
  const{css}=useSelector((store)=> store?.widgetSettings)
  const timeCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Salon Time"
  )?.fields
  const formatTime = (timeString) =>
    dayjs(timeString, "HH:mm:ss").format("HH:mm");

  const handleTimeSelect = (time) => {
    dispatch(setselectedTime(time));
    handleClose();
  };

  useEffect(() => {
    if (Ref?.current) {
      const rect = Ref?.current?.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // If input is near the bottom 150px of the viewport, show popover above
      if (rect.bottom + 400 > viewportHeight) {
        // 400 ~ popover height
        setAnchorOriginVert("top");
        setTransformOriginVert("bottom");
      } else {
        setAnchorOriginVert("bottom");
        setTransformOriginVert("top");
      }
    }
  }, [isOpen, Ref]);

  return (
    <Popover
      open={isOpen}
      anchorEl={Ref?.current}
      onClose={handleClose}
      anchorOrigin={{
        vertical: anchorOriginVert,
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: transformOriginVert,
        horizontal: "center",
      }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: 3,
          mt: 1,
          minWidth: 220,
          width: 250,
          maxHeight: 400,
          overflowY: "scroll", // enable scrolling
          scrollbarWidth: "none", // Firefox
          "-ms-overflow-style": "none", // IE 10+
          "&::-webkit-scrollbar": {
            display: "none", // Chrome, Safari, Edge
          },
          backgroundColor: timeCss?.salonMainBg,
        },
      }}
      disableEnforceFocus
      disableAutoFocus
      disableRestoreFocus
    >
      <Box sx={{padding: 0, position: "relative" }}>
      <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            my: 1.5,
          }}
        >
          <Typography
            sx={{
              color: timeCss?.salonHeadingTxtClr,
              fontSize: "14px",
              fontWeight: "bold",
              px:2,
            }}
          >
            {languageWords?.availableTime || "Available Time"}
          </Typography>
          </Box>
        <List sx={{ padding: 0 }}>
          {loader
            ? Array.from({ length: 5 }).map((_, index) => (
                <ListItem
                  key={index}
                  sx={{
                    borderBottom: "1px solid lightgrey",
                    py: 2,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Skeleton
                    variant="rounded"
                    width={200}
                    height={20}
                    sx={{ borderRadius: 2 }}
                  />
                </ListItem>
              ))
            : avilabilityTime?.map((time, index) => {
                const isSelected = selectedTime?.timeRange === time?.timeRange;
                return (
                  <ListItem
                    key={index}
                    button
                    onClick={() => handleTimeSelect(time)}
                    selected={isSelected}
                    sx={{
                //      px: 2,
                      py: 1.5,
                      backgroundColor: isSelected
                        ? timeCss?.salonItemHighlightBgClr
                        : timeCss?.salonItemBgClr,
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor:
                          timeCss?.salonItemBgHover,
                        color: timeCss?.salonItemTxtHover,
                      },
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <ListItemIcon sx={{ minWidth: "0", mr: 1 }}>
                        <AccessTimeIcon
                          sx={{
                            color: isSelected
                              ? timeCss?.salonIconHighlightClr
                              : timeCss?.salonIconClr,
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        secondary={time?.timeRange}
                        sx={{
                          "& .MuiListItemText-secondary": {
                            fontWeight: isSelected ? 600 : 400,
                            color: isSelected
                              ? timeCss?.salonItemTxtHighlightClr
                              : timeCss?.salonItemTxtClr,
                        

                            fontSize: "1.2rem",
                          },
                        }}
                      />
                    </Box>
                  </ListItem>
                );
              })}
        </List>
      </Box>
    </Popover>
  );
};

export default TimeComponent;
